import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import AddCustomerModal from '../../pages/customers/components/AddCustomerModal';
import AddProjectModal from '../../pages/projects/components/AddProjectModal';
import AddContractorModal from '../../pages/contractors/components/AddContractorModal';

const QuickAddMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [showContractorModal, setShowContractorModal] = useState(false);
  const [preSelectedCustomer, setPreSelectedCustomer] = useState(null);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const quickAddItems = [
    {
      label: 'Add Customer',
      icon: 'UserPlus',
      action: () => setShowCustomerModal(true)
    },
    {
      label: 'Add Project',
      icon: 'FolderPlus',
      action: () => setShowProjectModal(true)
    },
    {
      label: 'Add Contractor',
      icon: 'UserCog',
      action: () => setShowContractorModal(true)
    }
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (action) => {
    action();
    setIsOpen(false);
  };

  const handleModalSuccess = () => {
    // Reload current page to show new data
    window.location?.reload();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    // Listen for openProjectModal event from customer profile
    const handleOpenProjectModal = (event) => {
      setPreSelectedCustomer(event?.detail || null);
      setShowProjectModal(true);
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    window.addEventListener('openProjectModal', handleOpenProjectModal);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      window.removeEventListener('openProjectModal', handleOpenProjectModal);
    };
  }, [isOpen]);

  return (
    <>
      <div ref={menuRef} className="fixed z-[100]" style={{ bottom: 'max(24px, calc(env(safe-area-inset-bottom, 0px) + 24px))', right: '24px' }}>
        <style>{`
          @media (max-width: 767px) {
            .quick-add-wrapper {
              bottom: max(80px, calc(env(safe-area-inset-bottom, 0px) + 80px)) !important;
            }
          }
        `}</style>
        <div className={`quick-add-menu ${!isOpen ? 'closed' : ''}`}>
          {quickAddItems?.map((item, index) => (
            <button
              key={index}
              className="quick-add-menu-item w-full"
              onClick={() => handleItemClick(item?.action)}
            >
              <Icon name={item?.icon} size={20} />
              <span>{item?.label}</span>
            </button>
          ))}
        </div>
        <button
          className="quick-add-button"
          onClick={toggleMenu}
          aria-label="Quick add menu"
          aria-expanded={isOpen}
        >
          <Icon name={isOpen ? 'X' : 'Plus'} size={24} />
        </button>
      </div>

      <AddCustomerModal
        isOpen={showCustomerModal}
        onClose={() => setShowCustomerModal(false)}
        onSuccess={handleModalSuccess}
      />
      <AddProjectModal
        isOpen={showProjectModal}
        onClose={() => {
          setShowProjectModal(false);
          setPreSelectedCustomer(null);
        }}
        onSuccess={handleModalSuccess}
        preSelectedCustomer={preSelectedCustomer}
      />
      <AddContractorModal
        isOpen={showContractorModal}
        onClose={() => setShowContractorModal(false)}
        onSuccess={handleModalSuccess}
      />
    </>
  );
};

export default QuickAddMenu;